const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useCounter, useProgress } =
  window.BAO.Carousel.plugins

class ProductHotspot extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach((el) => {
        this.listeners.add(el, `click`, this.handleTrigger)
      })
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    const isSelected = triggerEl.getAttribute('aria-pressed') === 'true'

    if (isSelected) {
      triggerEl.setAttribute('aria-pressed', 'false')

      this.els.slide.elements.forEach((el) => {
        el.setAttribute('aria-selected', 'false')
      })
    } else {
      this.carousel.moveToIdx(parseInt(triggerEl.dataset.trigger, 10))

      this.els.trigger.elements.forEach((el) => {
        el.setAttribute(
          'aria-pressed',
          el.dataset.trigger === triggerEl.dataset.trigger,
        )
      })

      this.els.slide.elements.forEach((el) => {
        el.setAttribute(
          'aria-selected',
          el.dataset.product === triggerEl.dataset.trigger,
        )
      })
    }
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.1,
              spacing: 16,
            },
            loop: true,
          },
          '(min-width: 901px)': {
            slides: {
              perView: 2.2,
              spacing: 16,
            },
            loop: true,
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 2.66667,
              spacing: 16,
            },
            loop: true,
          },
        },
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useCounter({
          counter: this.els?.counter?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((el, index) => {
      el.setAttribute('aria-selected', index === currentSlide)

      if (index === currentSlide) {
        this.relatedProduct = el.dataset.product
      }
    })

    this.els.trigger.elements.forEach((el) => {
      el.setAttribute(
        'aria-pressed',
        el.dataset.trigger === this.relatedProduct,
      )
    })
  }
}

if (!customElements.get('product-hotspot')) {
  customElements.define('product-hotspot', ProductHotspot)
}
